export const SCENARIOS = {
  OFFER_HYBRID: 'offer-hybrid',
  OFFER_HYBRID_NO_PRODUCTS: 'offer-hybrid-no-products',
};
